import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CruiseService } from '../services/cruise.service';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-remove-cache',
  templateUrl: './remove-cache.component.html',
  styleUrls: ['./remove-cache.component.css']
})
export class RemoveCacheComponent implements OnInit {
  public reportType: any = "";

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private flightService: CruiseService) {
  }

  ngOnInit() {
  }

  search() {
    if (this.reportType == "Client") {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(["/"]);
    }
    if (this.reportType == "Server") {
      this.removemerchantCache();
      this.router.navigate(["/"]);
    }
    if (this.reportType == "Both") {
      localStorage.clear();
      sessionStorage.clear();
      this.removemerchantCache();
      this.router.navigate(["/"]);
    }

  }

  removemerchantCache() {
    this.flightService.removemerchantCache().subscribe(data => {
    }, error => console.log(error));
  }

}
